import React from 'react'
import { CommonModal } from '../../AbstractElements'
import { Row,Col } from 'reactstrap'
import { resetDriverLogin } from '../../Services/Driver.service' 
import { showAlert } from '../../Services/Shared.service'
const ResetDriver = ({Large,title,LargeModaltoggle,driverObj}) => {
  const submitResetDriver = ()=>{
    let obj={
      mobile:driverObj.mobile
    }
    resetDriverLogin(obj).then((result)=>{
      LargeModaltoggle()
      showAlert("success", "Driver Reset Successfully");
    }).catch((err)=>{
      
      showAlert('error',err?.response?.data?.message?err.response.data.message:'Something went wrong');
    })
  }
  return (
    <CommonModal
    isOpen={Large}
    title={title}
    toggler={LargeModaltoggle}
    size="md"
  >
    <Row className="driver-push-notification">
      <Col xl="12" className="push-botification-body">
        <div>Are you sure you want to Reset the Driver: {driverObj.fullName}?</div>
      </Col>
      <Col xl="12" className="push-notification-footer">
        <button className="btn btn-primary" type="submit" onClick={()=>submitResetDriver()}>Confirm</button>
      </Col>
    </Row>
  </CommonModal>
  )
}

export default ResetDriver